import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';

export interface PillTab {
    id: number;
    label: string;
}

@Component({
    selector: 'cdss-pill-tabs',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './pill-tabs.component.html',
    styleUrl: './pill-tabs.component.scss'
})
export class PillTabsComponent {
    @Input() tabs: PillTab[] = [];
    @Input() activeId: number | null = null;
    @Output() activeIdChange = new EventEmitter<number>();

    // Callers may pass a getter that builds fresh tab objects on every change
    // detection pass; tracking by id keeps the buttons (and their click
    // listeners) alive instead of re-creating them mid-click.
    trackById(_index: number, tab: PillTab): number {
        return tab.id;
    }

    selectTab(id: number): void {
        if (id === this.activeId) return;
        this.activeId = id;
        this.activeIdChange.emit(id);
    }
}
